type radioValues = {
  value: string | undefined;
  text: string | false | undefined;
  id?: number | string | undefined;
};

type Props = {
  label: string;
  value?: string | undefined | false;
  valuesArr?: radioValues[] | undefined;
  onClick?: (value: string | false | undefined) => void;
  error?: boolean;
  errorMsg?: string | null | undefined;
  disabled?: boolean;
};
export default function RaidoField(props: Props) {
  return (
    <div className="text-[#1E293B] space-y-2">
      <label className="block text-sm w-full">{props.label}</label>
      <div className="flex items-center space-x-6">
        {props.valuesArr?.map((v, i) => {
          const id = `radio-${v.value}-${i}`;
          return (
            <div
              className={`flex items-center ${
                props.disabled ? " opacity-60" : "cursor-pointer"
              }`}
              key={id}
            >
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="radio"
                  disabled={props.disabled}
                  id={id}
                  checked={props.value === v.value}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-slate-300 checked:border-[#FBD037] transition-all"
                  value={v.value}
                  onChange={({ target: { value } }) =>
                    props.onClick && props?.onClick(value)
                  }
                />
                <span className="absolute bg-[#FBD037] w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
              </label>
              <label
                htmlFor={id}
                className="ml-2 text-black cursor-pointer text-sm font-medium"
              >
                {v.text}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
